module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_vm._v("Abbreviations and Acronyms")])]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IK")])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Iskusstvo kino")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("LG")])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Literaturnaia gazeta")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TMG")])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Moscow Guardian")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TMT")])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Moscow Times")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NYT")])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NG")])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nezavisimaia gazeta")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SE")])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sovetskii ekran")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VDNKh")]), _vm._v(" "), _c('td', [_vm._v("Exhibition of Economic Achievements")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VGIK")]), _vm._v(" "), _c('td', [_vm._v("All-Union State Institute of Cinema")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VNIIK")]), _vm._v(" "), _c('td', [_vm._v("All-Union Scientific Research Institute of Film Art")])]), _vm._v(" "), _c('tr', [_c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WP")])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington Post")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aef33552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Abbreviations.vue
// module id = 78
// module chunks = 0